"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _main = _interopRequireDefault(require("../templates/main"));

var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _parseStrategy;

var parseStrategy = (_parseStrategy = {}, (0, _defineProperty2["default"])(_parseStrategy, _constants.PARSE_TYPE_ARRAY_BUFFER, _constants.FILE_READER_FUNCTION_ARRAY_BUFFER), (0, _defineProperty2["default"])(_parseStrategy, _constants.PARSE_TYPE_BASE_64, _constants.FILE_READER_FUNCTION_BASE_64), (0, _defineProperty2["default"])(_parseStrategy, _constants.PARSE_TYPE_BINARY, _constants.FILE_READER_FUNCTION_BINARY), (0, _defineProperty2["default"])(_parseStrategy, _constants.PARSE_TYPE_TEXT, _constants.FILE_READER_FUNCTION_TEXT), _parseStrategy);

var FileInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(FileInput, _Component);

  function FileInput(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, FileInput);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FileInput).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleButtonClick", function () {
      var _this$labelRef$curren;

      (_this$labelRef$curren = _this.labelRef.current) === null || _this$labelRef$curren === void 0 ? void 0 : _this$labelRef$curren.click();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleInputChange", function (e) {
      e.persist();
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          parseType = _this$props.parseType;

      if (typeof onChange === 'function') {
        onChange(e);
      }

      if (parseType) {
        _this.parseFiles(e.target);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "validateFiles", function (files) {
      var _this$props2 = _this.props,
          maxSize = _this$props2.maxSize,
          attribute = _this$props2.attribute;

      if (files.some(function (file) {
        return (file === null || file === void 0 ? void 0 : file.size) > maxSize;
      })) {
        return {
          name: attribute,
          message: 'FILE_INPUT_MAX_SIZE_EXCEEDED'
        };
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "parseFiles",
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(target) {
        var _this$props3, onParseStart, onParseEnd, onError, files, error, parsedFiles;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props3 = _this.props, onParseStart = _this$props3.onParseStart, onParseEnd = _this$props3.onParseEnd, onError = _this$props3.onError, files = Array.from(target === null || target === void 0 ? void 0 : target.files), error = _this.validateFiles(files);

                if (!error) {
                  _context.next = 5;
                  break;
                }

                onError(error);
                _context.next = 17;
                break;

              case 5:
                if (typeof onParseStart === 'function') {
                  onParseStart(files);
                }

                if (!files.length) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 7;
                _context.next = 10;
                return Promise.all(files.map(_this._promisifyParse));

              case 10:
                parsedFiles = _context.sent;

                if (typeof onParseEnd === 'function' && (parsedFiles === null || parsedFiles === void 0 ? void 0 : parsedFiles.length)) {
                  onParseEnd(parsedFiles);
                }

                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](7);
                onError(_context.t0);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 14]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_promisifyParse", function (file) {
      return new Promise(function (resolve, reject) {
        var _process, _process$env;

        var _this$props4 = _this.props,
            parseType = _this$props4.parseType,
            attribute = _this$props4.attribute,
            fileReader = new FileReader(),
            readerFnKey = parseStrategy[parseType],
            readFunction = fileReader[readerFnKey];

        fileReader.onload = function (e) {
          return (// this is the only way it works :)
            resolve({
              name: file.name,
              type: file.type,
              lastModified: file.lastModified,
              lastModifiedDate: file.lastModifiedDate,
              size: file.size,
              content: e.target.result
            })
          );
        };

        fileReader.onerror = function () {
          return reject({
            name: attribute,
            message: 'FILE_INPUT_PARSE_ERROR'
          });
        };

        if (typeof readFunction === 'function') {
          readFunction.call(fileReader, file);
        } else if (((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) !== 'production') {
          console.error("Invalid parse type supplied to FileInput ".concat(attribute));
        }
      });
    });
    _this.labelRef = _react["default"].createRef();
    _this.inputId = (0, _uniqueId2["default"])();
    return _this;
  }

  return FileInput;
}(_Component2["default"]);

(0, _defineProperty2["default"])(FileInput, "displayName", 'FileInput');
(0, _defineProperty2["default"])(FileInput, "propTypes", {
  onChange: _propTypes["default"].func,
  onParseEnd: _propTypes["default"].func,

  /**
   * for case when we need to show preloader for user
   */
  onParseStart: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  multiple: _propTypes["default"].bool,
  accept: _propTypes["default"].string,
  maxSize: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  attribute: _propTypes["default"].string.isRequired,
  parseType: _propTypes["default"].oneOf([_constants.PARSE_TYPE_BASE_64, _constants.PARSE_TYPE_TEXT, _constants.PARSE_TYPE_BINARY, _constants.PARSE_TYPE_ARRAY_BUFFER])
});
var _default = FileInput;
exports["default"] = _default;